import PropTypes from 'prop-types';
import { useEffect } from 'react';
import {  useNavigate } from 'react-router-dom';

// project-imports
import useAdminAuth from 'hooks/useAuth';

// ==============================|| AUTH GUARD ||============================== //

const AuthGuard = ({ children }) => {
  const { isLoggedIn } = useAdminAuth();
  const navigate = useNavigate();
  
  useEffect(() => {
    if (!isLoggedIn) {
      setTimeout(() => navigate('/'), 100);
    }
  }, [isLoggedIn, navigate]);
  return children;
};

AuthGuard.propTypes = {
  children: PropTypes.node
};

export default AuthGuard;
